import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { RoleDto, RolesApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseGetBuiltInRole = (
  id: string,
  options: Omit<UseQueryOptions<RoleDto, ErrorResponse, RoleDto, string[]>, 'queryKey' | 'queryFn'>,
) => UseQueryResult<RoleDto>;

export const useGetBuiltInRole: UseGetBuiltInRole = (id, options) => {
  const rolesApi = new RolesApi(getApiConfiguration());
  return useQuery(
    [`built-in-role-${id}`],
    () => rolesApi.getRole(id).then((res) => res.data),
    options,
  );
};
